import React, { useState } from "react"
import { reports_types } from "./reports_types"
import ReportDetailModal from "./ReportDetailModal"
const ReportsPage = () => {
  const [visible, setVisible] = useState( false )
  return (
    <div className="p-3 d-flex flex-column justify-center align-center">
      <ReportDetailModal visible={visible} setVisible={setVisible} />
      <div className="d-flex align-center">
        <h4>Gerar Relatórios</h4>
      </div>
      <div style={gridStyle}>
        {reports_types.map( ( type ) => {
          return (
            <div key={type.id} className="w-100 report-card p-3">
              <div style={{ minHeight: "200px" }}>
                <div className="w-100 d-flex flex-column align-center">
                  <h6
                    style={{
                      overflow: "hidden",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {type.nome}
                  </h6>
                  <p>
                    {type.descricao.split( "\n" ).map( ( line, index ) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ) )}
                  </p>
                  <div
                    className="w-100 d-flex flex-row"
                    style={{ justifyContent: "space-between", gap: "20px" }}
                  >
                    <button
                      style={buttonStyle}
                      onClick={() => setVisible( true )}
                    >
                      Observações
                    </button>
                    <button style={buttonStyle} onClick={() => type.action()}>
                      Gerar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        } )}
      </div>
    </div>
  )
}

export default ReportsPage

const gridStyle = {
  display: "grid",
  width: "100%",
  gridTemplateColumns: "1fr 1fr 1fr",
  gridTemplateRows: "auto",
  gap: "20px",
  marginTop: "10px",
}

const buttonStyle = {
  border: "none",
  width: "50%",
  height: "30px",
  cursor: "pointer",
  color: "#ffff",
  borderRadius: "5px",
  backgroundColor: "#499d96",
  textAlign: "center",
  outline: "none",
}
